import { useTopOfPageContent } from "@faire/retailer-visitor-shared/stores/ui/useTopOfPageContent";
import { useLoggedOutSuppliersPageFilterKeysQueryParams } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPageFilterKeysQueryParams";
import { debounceIfPossible } from "@faire/web/common/globals/debounceIfPossible";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { useEffect, useMemo, useRef } from "react";

export const useLoggedOutSuppliersPageScroll = () => {
  const scrollToBrandsSectionRef = useRef<HTMLDivElement>(null);

  const { heightWithoutPromoBannerExceptMarket } = useTopOfPageContent();

  const scrollToBrandsSection = useMemo(
    () =>
      debounceIfPossible(() => {
        const height = heightWithoutPromoBannerExceptMarket;
        if (scrollToBrandsSectionRef.current) {
          scrollToBrandsSectionRef.current?.scrollIntoView();
          getWindowOrThrow().scrollBy(0, -height);
        }
      }, 100),
    [heightWithoutPromoBannerExceptMarket]
  );

  return {
    scrollToBrandsSectionRef,
    scrollToBrandsSection,
  };
};

export const useLoggedOutSuppliersPageScrollOnFilterKeysChange = (
  scrollToBrandsSection: () => void
) => {
  const isFirstRun = useRef(true);
  const { filterKeys } = useLoggedOutSuppliersPageFilterKeysQueryParams();

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

    scrollToBrandsSection();
  }, [filterKeys, scrollToBrandsSection, isFirstRun]);
};
